import type { ElementType, HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  narrow?: boolean;
  animate?: boolean;
  padded?: boolean;
  children: ReactNode;
}

export function Card({ as: Tag = "div", narrow, animate, padded = true, className = "", children, ...rest }: CardProps) {
  const classes = ["card", padded && "card--padded", narrow && "card--narrow", animate && "card--enter", className]
    .filter(Boolean)
    .join(" ");
  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}
